import React, { useEffect, useState } from "react";
import "./header.css";

const THEME_KEY = "theme"; // "light" | "dark" | null

const getSystemTheme = () =>
  window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";

const applyTheme = (theme) => {
  if (theme === "light" || theme === "dark") {
    console.log("Applying theme", theme);
    document.documentElement.setAttribute("data-theme", theme);
  } else {
    console.log("Applying system theme");
    document.documentElement.removeAttribute("data-theme"); // follow system
  }
};

const Header = () => {
  const [Toggle, showMenu] = useState(false);
  const [activeNav, setActiveNav] = useState("/#home");
  const [theme, setTheme] = useState(null); // null = system

  useEffect(() => {
    const onScroll = () => {
      const header = document.querySelector(".header");
      if (!header) return;

      if (window.scrollY >= 80) header.classList.add("scroll-header");
      else header.classList.remove("scroll-header");
    };

    window.addEventListener("scroll", onScroll);
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    // Load saved preference
    const saved = localStorage.getItem(THEME_KEY);
    if (saved === "light" || saved === "dark") {
      setTheme(saved);
      applyTheme(saved);
    } else {
      setTheme(null);
      applyTheme(null);
    }
  }, []);

  useEffect(() => {
    // If no override, react to system changes
    const mql = window.matchMedia("(prefers-color-scheme: dark)");

    const onChange = () => {
      const saved = localStorage.getItem(THEME_KEY);
      if (saved === "light" || saved === "dark") return; // user override exists
      setTheme(null);
      applyTheme(null);
    };

    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else mql.addListener(onChange);

    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", onChange);
      else mql.removeListener(onChange);
    };
  }, []);

  const effectiveTheme = theme ?? getSystemTheme();
  const isDark = effectiveTheme === "dark";

  const toggleTheme = () => {
    const next = isDark ? "light" : "dark";
    setTheme(next);
    console.log("Setting theme to", next);
    localStorage.setItem(THEME_KEY, next);
    applyTheme(next);
  };

  const useSystemTheme = () => {
    localStorage.removeItem(THEME_KEY);
    setTheme(null);
    applyTheme(null);
  };

  return (
    <header className="header">
      <nav className="nav ">
        <a href="/#projects" className="nav__logo">
         
          HOPE
        </a>

        <div className={Toggle ? "nav_menu show-menu" : "nav_menu"}>
          <ul className="nav__list grid">
            <li className="nav__item">
              <a
                href="/#home"
                onClick={() => setActiveNav("#home")}
                className={activeNav === "#home" ? "nav__link active-link" : "nav__link"}
              >
                <i className="uil uil-estate nav__icon"></i>Home
              </a>
            </li>

            <li className="nav__item">
              <a
                href="/#about"
                onClick={() => setActiveNav("#about")}
                className={activeNav === "#about" ? "nav__link active-link" : "nav__link"}
              >
                <i className="uil uil-user nav__icon"></i>About
              </a>
            </li>

            <li className="nav__item">
              <a
                href="/#skills"
                onClick={() => setActiveNav("#skills")}
                className={activeNav === "#skills" ? "nav__link active-link" : "nav__link"}
              >
                <i className="uil uil-file-alt nav__icon"></i>Skills
              </a>
            </li>

            <li className="nav__item">
              <a
                href="/#services"
                onClick={() => setActiveNav("#services")}
                className={activeNav === "#services" ? "nav__link active-link" : "nav__link"}
              >
                <i className="uil uil-briefcase-alt nav__icon"></i>Services
              </a>
            </li>

            <li className="nav__item">
              <a
                href="/#projects"
                onClick={() => setActiveNav("#projects")}
                className={activeNav === "#projects" ? "nav__link active-link" : "nav__link"}
              >
                <i className="uil uil-scenery nav__icon"></i>Portfolio
              </a>
            </li>

            <li className="nav__item">
              <a
                href="/#contact"
                onClick={() => setActiveNav("#contact")}
                className={activeNav === "#contact" ? "nav__link active-link" : "nav__link"}
              >
                <i className="uil uil-message nav__icon"></i>Contact
              </a>
            </li>
          </ul>

          <i className="uil uil-times nav__close" onClick={() => showMenu(false)}></i>
        </div>

        <button
          type="button"
          className="theme__toggle"
          onClick={toggleTheme}
          aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
          title={isDark ? "Light mode" : "Dark mode"}
        >
          <i className={isDark ? "uil uil-sun" : "uil uil-moon"}></i>
        </button>

    

        <div className="nav__toggle" onClick={() => showMenu((v) => !v)}>
          <i className="uil uil-apps"></i>
        </div>
      </nav>
    </header>
  );
};

export default Header;
